import { useState } from "react";

// Renders an official brand logo as a monochrome warm-white mark.
// Falls back to a typographic wordmark when no logo file is set or it fails to load.
export const BrandLogo = ({ brand, index }) => {
  const [failed, setFailed] = useState(false);
  const showImage = brand.logo && !failed;

  return (
    <div
      data-testid={`brand-${index}`}
      title={brand.name}
      className="group flex h-12 shrink-0 items-center md:h-14"
    >
      {showImage ? (
        <img
          src={brand.logo}
          alt={brand.name}
          loading="lazy"
          onError={() => setFailed(true)}
          data-testid={`brand-logo-${index}`}
          className="brand-logo h-full w-auto max-w-[9rem] object-contain md:max-w-[11rem]"
        />
      ) : (
        <span
          data-testid={`brand-text-${index}`}
          className="whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.18em] text-ash transition-colors duration-300 group-hover:text-cream md:text-base"
        >
          {brand.name}
        </span>
      )}
    </div>
  );
};
